<infm-sliding-menu
  [title]="titleSliding() | translate"
  [actions]="actionsSliding()"
  (actionClick)="onActionClickSliding($event)"
>
  <div
    class="wrapper"
    infSwipe
    (swipeEnd)="onSwipeEnd($event)"
    [ngClass]="{ 'with-search': isSearchActive() }"
  >
    @if (isSearchActive()) {
      <div class="search">
        <infm-input-text (update)="onUpdateSearch($event)" />
      </div>
    }
    <div class="list" #list>
      <infm-list2
        [items]="displayedItems()"
        [isMultiple]="isMultiple()"
        [searchValue]="currentSearch()"
        (itemChange)="onItemChange($event)"
        (clickGroup)="onClickGroup($event)"
      />
    </div>
  </div>
</infm-sliding-menu>
